import { SignIn } from '@clerk/react'
import { Logo, Wordmark } from '@/components/Logo'

export function AuthScreen() {
  return (
    <div className="relative grid min-h-screen place-items-center overflow-hidden bg-paper p-4">
      <div className="relative flex w-full max-w-md animate-scale-in flex-col items-center">
        <div className="mb-6 flex justify-center">
          <Wordmark size={40} />
        </div>

        <SignIn />

        <div className="mt-6 flex justify-center opacity-60">
          <Logo size={24} />
        </div>
      </div>
    </div>
  )
}
